﻿import * as React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { RouteComponentProps } from 'react-router-dom';
import "./Career.css";

class Career extends React.PureComponent<{}, { isOpen: boolean }> {
    public state = {
        isOpen: false
    };

    public render() {
        return (
            <div className="career">
                <div className="page-banner" style={{
                    backgroundImage: 'url("../img/career-jobopening.jpg")'
                }}>
                    <h1>Career Opportunities</h1>
                </div>
                <Container>
                    <Row>
                        <Col className="content">
                            <p>Looking for a fun place to work, with a flexible schedule and competitive pay? Then come join us!</p>
                            <p>Working with Premier Pressure is unlike any other job.  Your day is filled with many satsifying accomplishments. No prior skills are needed. We offer paid training to get you ready for the job.</p>

                            <h2>Your Journey Starts Here</h2>
                            <p>You are one step closer. Start by contacting us at: <a href="mailto:info@premierpressurewash.com">info@premierpressurewash.com</a>. We&apos;ll reach out within 24 to 48 hours.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="video-container"><iframe width="560" height="315" src="https://www.youtube.com/embed/M9IxXpMMRpk" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe></Col>
                    </Row>
                    <Row>
                        <Col>
                            <br />
                            <br />
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    };
}

export default Career;